import React from "react";
import { Outlet } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Domestic from "./Domestic";
import ClientReviews from "./ClientReviews";
import Footer from "./Footer";
import Navr from "../Navbar/Navr";
import Why from "./Why";
import Slider from "./Slider";
export default function Main() {
  return (
    <div>
      <Navr />
      <Slider />
      <Domestic />
      <Why />
      <ClientReviews />
      <Footer />
      <Outlet />
    </div>
  );
}
